var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"index position-relative w-100 h-100"},[_c('AppHeader'),_c('main',{staticClass:"index__main position-relative w-100 h-100"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }